import { gql } from "@apollo/client";

export const GET_ALL_VEHICLE_TYPES = gql`
    query GetAllVehicleTypes {
        allVehicleTypes: getAllVehicleTypes {
            id
            nameZh
            nameEn
            nameEs
            defaultMaxWeightLbs
            defaultMaxVolumeFt3
            defaultLengthFt
            defaultWidthFt
            defaultHeightFt
            status
        }
    }
`;

/**
 * vehicle_type.status 的启用值。
 *
 * DDL：`status TINYINT(4) NOT NULL DEFAULT 1 COMMENT '状态：0-停用，1-启用'`。
 * 抽成常量而不是各处写字面量 1 —— 车型下拉在多个业务域都要按它过滤，
 * 散落的魔法数字改起来会漏。
 */
export const VEHICLE_TYPE_STATUS_ENABLED = 1;

export interface VehicleType {
    id: number;
    nameZh: string;
    nameEn: string;
    nameEs: string;
    defaultMaxWeightLbs?: number;
    defaultMaxVolumeFt3?: number;
    defaultLengthFt?: number;
    defaultWidthFt?: number;
    defaultHeightFt?: number;
    status: number;
}

export interface VehicleTypeResponse {
    allVehicleTypes: VehicleType[];
}

export const FIND_VEHICLE_TYPE_BY_ID = gql`
    query FindVehicleTypeById($id: Long!) {
        findVehicleTypeById(id: $id) {
            id
            nameZh
            nameEn
            nameEs
            defaultMaxWeightLbs
            defaultMaxVolumeFt3
            defaultLengthFt
            defaultWidthFt
            defaultHeightFt
            status
        }
    }
`;

export interface FindVehicleTypeByIdResponse {
    findVehicleTypeById: VehicleType | null;
}

